"use client";

import { useEffect } from "react";

export default function ErrorPage({
  reset,
  error,
}: {
  reset: () => void;
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4">
      <p className="text-lg">Bir sorun oluştu, lütfen tekrar deneyin.</p>
      <button
        className="rounded-md bg-primary px-4 py-2 text-sm"
        onClick={reset}
        type="button"
      >
        Tekrar Dene
      </button>
    </div>
  );
}
